module.exports = __webpack_public_path__ + "img/seo_gegame_item02.8bd58d2.webp";